import React from 'react';
import { FiFileText } from 'react-icons/fi';
import './QuoteButton.css';

/**
 * QuoteButton component for navigating to the project summary page
 * 
 * @param {Object} props - Component props
 * @param {Object} props.sensorCounts - Counts of different sensor types
 * @param {string} props.projectName - Name of the project
 * @param {Function} props.onShowSummary - Function to show the summary page
 * @param {Function} props.saveProject - Function to save the project before showing summary
 * @returns {JSX.Element} QuoteButton component
 */
const QuoteButton = ({ sensorCounts, projectName, onShowSummary, saveProject }) => {
  // Check if we have any sensors
  const hasSensors = sensorCounts && Object.values(sensorCounts).some(count => count > 0);

  // Handle click - save first, then show summary
  const handleClick = async () => {
    // Save project first if saveProject function is provided
    if (saveProject) {
      await saveProject();
    }
    // Then show summary
    onShowSummary();
  };

  return (
    <button
      className="quote-button"
      onClick={handleClick}
      title={hasSensors ? 'View project summary' : 'Add sensors to view summary'}
      disabled={!hasSensors}
      aria-label="View project summary"
    >
      <FiFileText />
      <span>Summary</span>
    </button>
  );
};

export default QuoteButton; 